export default __webpack_public_path__ + "static/media/(23).c219ee57.jpeg";